import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { pathOr } from 'ramda'

const state = {
  killerFeatureDisplaySettings: {}
}

const getters = {
  getKillerFeatureDisplaySettings: state => state.killerFeatureDisplaySettings
}

const actions = {
  async putKillerFeatureDisplaySettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.killerFeatureDisplaySettings.updateKillerFeatureDisplaySettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Sell killer message updated')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sell killer message failed to update')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchKillerFeatureDisplaySettings ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.publicSettings.getPublicSettings())
      commit(types.SET_KILLER_FEATURE_DISPLAY_SETTINGS, pathOr({}, ['setting', 'killerFeatureDisplaySetting'], data))
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sell killer message failed to fetch')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_KILLER_FEATURE_DISPLAY_SETTINGS] (state, settings) {
    state.killerFeatureDisplaySettings = settings
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/killerFeatureDisplaySettings.js